// Card-related addresses and constants
import { getAddress } from 'viem'

// Note: BRAHMA_ADDRESS (credit receiver) is now fetched dynamically from the backend
// to ensure consistency with the backend's tenant configuration

export const A_USDT_DEBT = getAddress('0x31f3fbad8b3d2136546e2032bec791f6d167d277') // debt token address
export const A_USDT_ADDRESS = getAddress('0x1ca7e21b2daa5ab2eb9de7cf8f34dcf9c8683007') // aToken address for approvals
export const USDT_ADDRESS = getAddress('0xb8ce59fc3717ada4c02eadf9682a9e934f625ebb') // underlying USDT token

// Default approval/delegation limit (in whole token units, e.g., 1000 = 1000 USDC)
// Used as fallback when user's configured limit is not available
// Backend multiplies this by 10^decimals to get the raw amount
export const DEFAULT_APPROVAL_LIMIT = 1000
